import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    TrialItemCategoryActions,
    ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID,
    ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_SUCCESS,
    ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_FAILURE,
    ACTION_TRIALITEMCATEGORIES_CLEAR,
    ACTION_TRIALITEMCATEGORIES_FILTER
} from '../actions/trialItemCategory';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialItemCategoryState {
    formData: Dtos.TrialItemCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialItemCategory[];
    formLength: number;
}

const initialState: ITrialItemCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialItemCategoryState, _isLoading: boolean): ITrialItemCategoryState {
    const newState: ITrialItemCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ITrialItemCategoryState,
    formData: Dtos.TrialItemCategory[],
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialItemCategoryState {
    const newState: ITrialItemCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialItemCategoryState, formFilter: IFormFilter): ITrialItemCategoryState {

    const trialItemCategories: Dtos.TrialItemCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = trialItemCategories ? trialItemCategories.length : 0;

    const formFilteredData = trialItemCategories ? trialItemCategories.filter(p => (formFilter.showInActive) &&
        (formFilter.search == "" || p.category.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: ITrialItemCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function loadFailure(state: ITrialItemCategoryState, responseStatus: Dtos.ResponseStatus): ITrialItemCategoryState {
    const newState: ITrialItemCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialItemCategoryState, propertiesToClear?: string[]): ITrialItemCategoryState {

    if (!propertiesToClear) {
        const newState: ITrialItemCategoryState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const TrialItemCategoryReducer: Reducer<ITrialItemCategoryState> = (state: ITrialItemCategoryState = initialState, action: TrialItemCategoryActions) => {
    switch (action.type) {
        case ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID:
            return loading(state, true);
        case ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_SUCCESS:
            return loadSuccess(state, action.formData, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALITEMCATEGORIES_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALITEMCATEGORIES_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default TrialItemCategoryReducer;